<template>
  <div>
    <dialog-loading loadingText="Deletando..." v-if="deleting"></dialog-loading>
    <v-card elevation="0">
      <v-card-text class="pa-0 pt-2">
        <date-search v-if="with_date_search" @onDateSearch="handleDateSearch"></date-search>
        <v-data-table
          :headers="headers"
          :items="loading? [] : items"
          class="elevation-0"
          :search="tableSearch"
          ref="table"
          :loading='loading'
          mobile-breakpoint="1"
          @click:row="showDeposit"
        >
          <template v-slot:top>
            <v-row justify="center" class="mb-5">
              <v-col cols='5'>
                <v-card style="border-radius:12px">
                  <v-card-text class="px-2 py-1">
                    <v-row align="center" class="px-5 py-2" justify="center">
                      <v-icon x-large class="mr-5" color='blue-grey darken-3'>mdi-currency-usd</v-icon>
                      <span class="title">{{ total_value_sum?.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}</span>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols='5'>
                <v-card style="border-radius:12px">
                  <v-card-text class="px-2 py-1">
                    <v-row align="center" class="px-5 py-2" justify="center">
                      <v-icon x-large class="mr-5" color='blue-grey darken-3'>mdi-credit-card-outline</v-icon>
                      <span class="title">{{ total_deposits }} depósitos</span>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </template>
          <template v-slot:item.attributes.deposit_date="{item}">
            <v-icon v-if="item.attributes.status_id != status_id_map['Concluded']" :color="checkDepositAvailable(item).color">{{checkDepositAvailable(item).icon}}</v-icon>
            {{ $moment(item.attributes.deposit_date.substring(0,10)).format('L') }}
          </template>

          <template v-slot:item.attributes.value="{item}">
            {{ item.attributes.value?.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}
          </template>

          <template v-slot:item.attributes.entrance_value="{item}">
            {{ item.attributes.entrance_value?.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}
          </template>

          <template v-slot:item.attributes.one_day_value="{item}">
            {{ item.attributes.one_day_value?.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}
          </template>

          <template v-slot:item.attributes.two_days_value="{item}">
            {{ item.attributes.two_days_value?.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}
          </template>

          <template v-slot:item.attributes.concluded_by_name="{item}">
            <v-icon color='amber' v-if="item.attributes.returned">mdi-alert</v-icon>
            <div v-if="!item.attributes.returned">
              {{ item.attributes.concluded_by_name }}
            </div>
          </template>

          <template v-slot:item.attributes.concluded_at="{item}">
            <v-icon color='amber' v-if="item.attributes.returned">mdi-alert</v-icon>
            <div v-if="!item.attributes.returned">
              {{ item.attributes.concluded_at? $moment(item.attributes.concluded_at.substring(0,10)).format('L') : '---' }}
            </div>
          </template>

          <template v-slot:item.attributes.status_id="{item}">
            <div class="d-flex align-center">
              <v-btn v-if="item.attributes.status_id == status_id_map['Payed'] || item.attributes.status_id == status_id_map['Confirmed']" x-small fab class="elevation-0 ml-1 mr-2" color="success" @click="showDeposit(item)">
                <v-icon>mdi-bank-check</v-icon>
              </v-btn>
              <v-btn v-if="item.attributes.status_id == status_id_map['Payed'] || item.attributes.status_id == status_id_map['Confirmed']" fab class="elevation-0" x-small color="error" @click="showDeposit(item)">
                <v-icon>mdi-alert-circle</v-icon>
              </v-btn>
              <v-tooltip bottom v-if="canManageDepositActions">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="deletePayment(item)" v-bind="attrs" v-on="on" x-small outlined fab class="ml-1 mr-2" color="error">
                    <v-icon>mdi-trash-can</v-icon>
                  </v-btn>
                </template>
                <span>Excluir pagamento</span>
              </v-tooltip>
            </div>
          </template>

          <template v-slot:item.attributes.concluded_by="{item}">
            {{ concludedBy(item) }}
          </template>

          <template v-slot:item.attributes.details="{item}">
            <v-btn small color="primary" rounded dark @click="showDeposit(item)">ver</v-btn>
            
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <deposit-dialog :deposit="deposit?.attributes" :deposit_dialog="deposit_dialog" @closeDepositDialog="closeDialog" @doneUpdate="handleDoneUpdate" @doneReturned="handleDoneReturned" @doneDelete="handleDoneDelete"></deposit-dialog>

  </div>
</template>

<script>
import Api from '@/api/index';
import status from "@/_backoffice/_financial/mixins/status.js"
export default {
  name: 'DepositTable',
  mixins: [ status ],
  props: {
    items: {
      type: Array
    },
    title: {
      type: String
    },
    with_date_search: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    headers_kind:{
      type: String,
      default: 'default'
    },
    /** Texto vindo do FilterData (busca no `v-data-table`). */
    tableSearch: {
      type: String,
      default: ''
    },

  },
  components: {
    DateSearch: () => import('@/_backoffice/_financial/components/shared/DateSearch.vue'),
    DepositDialog: () => import('./DepositDialog'),
  },
  data() {
    return {
      deleting: false,
      deposit_dialog: false,
      deposit: {},
      initial_date_menu: false,
      end_date_menu: false,
      initial_date: null,
      end_date: null,
      select_status: null,
      checkbox_item: null,

      loading_one_deposit: false,
    }
  },
  computed: {
    headers(){
      if(this.headers_kind == 'completed'){
        return [
          { text: 'Id', value: 'attributes.id', align: 'center' },
          { text: 'Módulo', value: 'attributes.place_name', align: 'center' },
          { text: 'Depositado em', value: 'attributes.deposit_date', align: 'center' },
          { text: 'Cliente', value: 'attributes.client_name', align: 'center' },
          { text: 'Banco', value: 'attributes.deposit_bank', align: 'center' },
          { text: 'Empresa', value: 'attributes.deposit_company', align: 'center' },
          { text: 'Valor total', value: 'attributes.value', align: 'center' },
          { text: 'Valor à vista', value: 'attributes.entrance_value', align: 'center' },
          { text: 'Bloqueado 1 dia', value: 'attributes.one_day_value', align: 'center' },
          { text: 'Bloqueado 2 dias', value: 'attributes.two_days_value', align: 'center' },
          { text: 'Concluído em', value: 'attributes.concluded_at', align: 'center' },
          { text: 'Concluído por', value: 'attributes.concluded_by', align: 'center' },
          { text: 'Detalhes', value: 'attributes.details', align: 'center' },
        ]
      }else{
        return [
          { text: 'Id', value: 'attributes.id', align: 'center' },
          { text: 'Módulo', value: 'attributes.place_name', align: 'center' },
          { text: 'Depositado em', value: 'attributes.deposit_date', align: 'center' },
          { text: 'Cliente', value: 'attributes.client_name', align: 'center' },
          { text: 'Banco', value: 'attributes.deposit_bank', align: 'center' },
          { text: 'Empresa', value: 'attributes.deposit_company', align: 'center' },
          { text: 'Valor total', value: 'attributes.value', align: 'center' },
          { text: 'Valor à vista', value: 'attributes.entrance_value', align: 'center' },
          { text: 'Bloqueado 1 dia', value: 'attributes.one_day_value', align: 'center' },
          { text: 'Bloqueado 2 dias', value: 'attributes.two_days_value', align: 'center' },
          { text: 'Acão', value: 'attributes.status_id', align: 'center' },
          { text: 'Concluído por', value: 'attributes.concluded_by', align: 'center' },
        ]
      }
    },
    canManageDepositActions() {
      return this.isDirector() || this.isAnalyst()
    },
    total_value_sum() {
      if (this.$refs.table && this.tableSearch) {
        return this.$refs.table.internalCurrentItems.reduce((acc, one) => acc + Number(one.attributes.value), 0)
      }
      return this.items.reduce((acc, one) => acc + Number(one.attributes.value), 0)
    },
    total_deposits() {
      if (this.$refs.table && this.tableSearch) {
        return this.$refs.table.internalCurrentItems.length
      }
      return this.items.length
    },
  },
  methods: {
    deletePayment(item){
      this.swallConfirmation({
          title: 'Deseja EXCLUIR o pagamento?',
          icon: 'warning',
        }).then( confirmed =>{
          if (confirmed ) {
            this.deleting = true
            let payment_id = item.attributes.payment_id
            Api.Payment.delete(payment_id).then(res => {
              this.successDeleted()
            }).catch(err => {
              this.errorUpdated()
            }).finally(()=>{
              this.deleting = false
              this.$emit('doneUpdate')
            })
          }
        })     
    },
    concludedBy(item){
      return item?.attributes?.concluded_by || ''
    },
    checkDepositAvailable(item) {
      const options = {
        available: {
          icon: 'mdi-checkbox-marked',
          color: 'success',
        },
        one_day: {
          icon: 'mdi-numeric-1-circle',
          color: 'orange',
        },
        two_days: {
          icon: 'mdi-numeric-2-circle',
          color: 'orange',
        },
        more_than_two_days: {
          icon: 'mdi-plus-circle-multiple-outline',
          color: 'purple',
        },
      }

      let time = 'available'

      const today = this.$moment()
      const deposit_date = this.$moment(item.attributes.deposit_date.substring(0,10))

      let days_diff = today.startOf('day').diff(deposit_date, 'days')

      if ( item.attributes.two_days_value){
        if (days_diff == 2) {
          time = 'one_day'
        } else if (days_diff > 2) {
          time = 'available'
        } else if (days_diff == 1) {
          time = 'two_days'
        } else {
          time = 'more_than_two_days'
        }
      } else if (item.attributes.one_day_value) {
        if (days_diff == 1) {
          time = 'one_day'
        } else if (days_diff == 0) {
          time = 'two_days'
        } else if (days_diff < 2) {
          time = 'more_than_two_days'
        } else if (days_diff > 2) {
          time = 'available'

        }
      } else if (item.attributes.entrance_value) {
        time = 'available'
      }

      return options[time]
    },
    showDeposit(item) {
      this.loading_one_deposit = true
      this.deposit_dialog = true
      this.deposit = null
      this.deposit = {...item}
      this.loading_one_deposit = false
    },

    closeDialog() {
      this.deposit = null
      this.deposit_dialog = false
    },
    handleDateSearch(e){
      this.$emit('dateSearched', e)
    },
    handleDoneUpdate(){
      this.deposit_dialog = false
      this.$emit('doneUpdate')
    },
    handleDoneReturned(){
      this.deposit_dialog = false
      this.$emit('doneReturned')
    },
    handleDoneDelete(){
      this.deposit_dialog = false
      this.$emit('doneDelete')
    },
  },
  watch: {
    loading(nv,ov) {
      if (nv){
      }
    }
  },
}
</script>
